import { render, staticRenderFns } from "./GameList.vue?vue&type=template&id=0282bce4&scoped=true&"
import script from "./GameList.vue?vue&type=script&lang=ts&"
export * from "./GameList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0282bce4",
  null
  
)

export default component.exports